import React from 'react'
import { Form } from 'react-bootstrap';

const AGE_CATEGORY_OPTIONS = [
    { value: 'under_14', label: 'Under 14' },
    { value: 'under_19', label: 'Under 19' },
    { value: 'womens_19_25', label: "Women's 19-25" },
    { value: 'para_open', label: 'Para-Athlete (Open)' },
];

const CmTrophyAgeCategoryFilter = ({ className = " ", value, onChange }) => {
    return (
        <>
            <div className="">
                <Form.Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                > <option value="">All Age Categories</option>
                    {AGE_CATEGORY_OPTIONS.map((item) => {
                        return (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default CmTrophyAgeCategoryFilter
